export const _social_slideshow = [
    {
      image_url: "/media/social/3.jpg",
      link: "https://www.instagram.com/p/C9KTx05opQ-/",
      title_color: "text-white",
    },
    {
      image_url: "/media/social/1.jpg",
      link: "https://www.instagram.com/p/C9MiTLfoVUh/",
      title_color: "text-white",
    },
    {
      image_url: "/media/social/2.jpg",
      link: "https://www.instagram.com/p/C9fa_uZoUMm/",
      title_color: "text-white",
    }
  ];
  